import { Spin } from 'antd';
import classnames from 'classnames';
import React, { useMemo, useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { humanize } from '@utils';

import Sorter from '../Sorter';
import styles from './index.less';
import { ESorterOrder, ESorterType, IHeader, ISorterOrderWithType } from './typed';

const Loading = <LoadingOutlined style={{ color: '#949494', fontSize: '11px' }} spin />;

const TableHeader = ({
  loading = false,
  openNameSort = false,
  count = 0,
  onClick,
  showTotal = false,
}: IHeader) => {
  const [sorterOrder, setSorterOrder] = useState<ISorterOrderWithType>({
    sorterOrder: ESorterOrder.NORMAL,
    type: ESorterType.EVENT,
  });

  const eventCount = useMemo(() => {
    return humanize(count, '');
  }, [count]);

  let nameSorterOrder = ESorterOrder.NORMAL;
  let eventSorterOrder = ESorterOrder.NORMAL;
  if (sorterOrder.type === ESorterType.NAME) {
    nameSorterOrder = sorterOrder.sorterOrder;
  } else if (sorterOrder.type === ESorterType.EVENT) {
    eventSorterOrder = sorterOrder.sorterOrder;
  }

  const handleSorterClick = (type: ESorterType) => {
    if (loading) return;
    setSorterOrder((prev) => {
      if (prev.type !== type) {
        const newState = {
          type,
          sorterOrder: ESorterOrder.DESC,
        };
        onClick?.(newState);
        return newState;
      }
      let nextOrder;
      switch (prev.sorterOrder) {
        case ESorterOrder.NORMAL:
          nextOrder = ESorterOrder.DESC;
          break;
        case ESorterOrder.DESC:
          nextOrder = ESorterOrder.ASC;
          break;
        case ESorterOrder.ASC:
          nextOrder = ESorterOrder.NORMAL;
          break;
      }
      const newState = {
        type,
        sorterOrder: nextOrder,
      };
      onClick?.(newState);
      return newState;
    });
  };

  return (
    <div className={styles.tableHeader}>
      <div
        className={classnames(styles.sorterContainer, { [styles.closeSort]: !openNameSort })}
        onClick={() => {
          openNameSort && handleSorterClick(ESorterType.NAME);
        }}
      >
        <div>Name</div>
        {openNameSort && <Sorter sortOrder={nameSorterOrder} />}
      </div>
      <div
        className={styles.sorterContainer}
        onClick={() => {
          handleSorterClick(ESorterType.EVENT);
        }}
      >
        <Sorter sortOrder={eventSorterOrder} />
        {showTotal && (
          <div className={styles.countContainer}>
            <span>Total Events</span>
            {loading ? <Spin indicator={Loading} /> : <span>{eventCount}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export default TableHeader;
